import React from "react";
import AboutUs from "../pages/AboutUs/AboutUs";
import ApiMsgLog from "../pages/ApiMsgLog/ApiMsgLog";
import AthenaSettings from "../pages/AthenaHealthSettings/AthenaSetting/AthenaSettings";
import AthenaTransactionAdd from "../pages/AthenaTransactions/AddAthenaTransaction/AthenaTransactionAdd";
import AthenaTransactionProfile from "../pages/AthenaTransactions/AthenaTransactionProfile/AthenaTransactionProfile";
import AthenaTransactions from "../pages/AthenaTransactions/AthenaTransactions";
import ContactUs from "../pages/ContactUs/ContactUs";
import CreateCustomFields from "../pages/CustomFieldsManagement/CreateCustomFields";
import CustomFieldsManagement from "../pages/CustomFieldsManagement/CustomFieldsManagement";
import EditCustomFields from "../pages/CustomFieldsManagement/EditCustomFields";
import Dashboard from "../pages/Dashboard";
import Faq from "../pages/FAQs/Faq";
import AddItem from "../pages/InventoryManagements/AddInventory/AddItem";
import InventoryProfile from "../pages/InventoryManagements/InventoryProfile/InventoryProfile";
import Itemlisting from "../pages/InventoryManagements/Itemlisting/Itemlisting";
import OrderDetail from "../pages/InventoryOrder/InventoryOrderDetail/OrderDetail";
import InventoryOrderList from "../pages/InventoryOrder/InventoryOrderList/InventoryOrderList";
import AddItemType from "../pages/ItemTypeMaster/AddItemType/AddItemType";
import ItemTypeListing from "../pages/ItemTypeMaster/ItemTypeListing/ItemTypeListing";
import ItemTypeProfile from "../pages/ItemTypeMaster/ItemTypeProfile/ItemTypeProfile";
import AddWarningItem from "../pages/ItemWarningMaster/AddWarningItem/AddWarningItem";
import WarningItemListing from "../pages/ItemWarningMaster/WarningItemListing/WarningItemListing";
import WarningItemProfile from "../pages/ItemWarningMaster/WarningItemProfile/WarningItemProfile";
import AddLabel from "../pages/LabelMaster/AddLabel/AddLabel";
import LabelDetails from "../pages/LabelMaster/LabelDetails/LabelDetails";
import LabelListing from "../pages/LabelMaster/LabelListing/LabelListing";
import AddLocation from "../pages/LocationMaster/AddLocation/AddLocation";
import LocationListing from "../pages/LocationMaster/LocationListing/LocationListing";
import LocationProfile from "../pages/LocationMaster/LocationProfile/LocationProfile";
import AddUserProfile from "../pages/LoginUserProfile/AddUserProfile/AddUserProfile";
import LoginUserProfile from "../pages/LoginUserProfile/Userprofile/LoginUserProfile";
import AddOrderingProduct from "../pages/OrderingProductMaster/AddOrderingProduct/AddOrderingProduct";
import OrderingProductListing from "../pages/OrderingProductMaster/OrderingProductListing/OrderingProductListing";
import OrderingProductProfile from "../pages/OrderingProductMaster/OrderingProductProfile/OrderingProductProfile";
import AddPatients from "../pages/PatientsMaster/AddPatients/AddPatients";
import PatientProfile from "../pages/PatientsMaster/PatientProfile/PatientProfile";
import PatientsListing from "../pages/PatientsMaster/PatientsListing/PatientsListing";
import Predictions from "../pages/Predictions/Predictions";
import AddProductMaster from "../pages/ProductMaster/AddProductMaster/AddProductMaster";
import ProductMasterListing from "../pages/ProductMaster/ProductMasterListing/ProductMasterListing";
import ProductMasterProfile from "../pages/ProductMaster/ProductMasterProfile/ProductMasterProfile";
import Records from "../pages/Records";
import AddRefrigerator from "../pages/RefrigeratorManagement/AddRefrigerator/AddRefrigerator";
import RefrigeratorList from "../pages/RefrigeratorManagement/RefrigeratorListing/RefrigeratorList";
import AdjusmentDetailsReport from "../pages/Reports/AdjusmentDetailsReport/AdjusmentDetailsReport";
import CostHistoryReport from "../pages/Reports/CostHistoryReport/CostHistoryReport";
import EmailExpiredInventoryReport from "../pages/Reports/EmailExpiredInventoryReport/EmailExpiredInventoryReport";
import ExpiringInventoryReport from "../pages/Reports/ExpiringInventoryReport/ExpiringInventoryReport";
import InventoryExpireReport from "../pages/Reports/InventoryExpireReport/InventoryExpireReport";
import InventoryStatusReport from "../pages/Reports/InventoryStatusReport/InventoryStatusReport";
import LocationsList from "../pages/Reports/LocationsList/LocationsList";
import LotSearchItem from "../pages/Reports/LotSearchItem/LotSearchItem";
import LotSearchPatients from "../pages/Reports/LotSearchPatients/LotSearchPatients";
import MedicationsList from "../pages/Reports/MedicationsList/MedicationsList";
import OrderingProductInventoryReport from "../pages/Reports/OrderingProductInventoryReport/OrderingProductInventoryReport";
import OrderingProductReport from "../pages/Reports/OrderingProductReport/OrderingProductReport";
import ProvidersList from "../pages/Reports/ProvidersList/ProvidersList";
import RecalledInventoryReport from "../pages/Reports/RecalledInventoryReport/RecalledInventoryReport";
import InventoryReceivingReport from "../pages/Reports/ReceivingDetailsReport/InventoryReceivingReport";
import ReconReport from "../pages/Reports/ReconciliationReport/ReconReport";
import RxHistoryReport from "../pages/Reports/RxHistoryReport/RxHistoryReport";
import TransferDetailsReport from "../pages/Reports/TransferDetailsReport/TransferDetailsReport";
import UsageDetailsReport from "../pages/Reports/UsageDetailsReport/UsageDetailsReport";
import UsersList from "../pages/Reports/UsersList/UsersList";
import AddRole from "../pages/RolePermission/AddRole/AddRole";
import RoleListing from "../pages/RolePermission/RoleListing/RoleListing";
import AddSetting from "../pages/Settings/AddSetting/AddSetting";
import Settings from "../pages/Settings/SettingListing/SettingsListing";
import SettingProfile from "../pages/Settings/SettingProfile/SettingProfile";
import AddStock from "../pages/StockMaster/AddStock/AddStock";
import StockListing from "../pages/StockMaster/StockListing/StockListing";
import StockProfile from "../pages/StockMaster/StockProfile/StockProfile";
import Tickets from "../pages/Tickets/Tickets";
import TRReport from "../pages/TrReport/TRReport";
import AddUnit from "../pages/UnitMaster/AddUnit/AddUnit";
import UnitListing from "../pages/UnitMaster/UnitListing/UnitListing";
import UnitProfile from "../pages/UnitMaster/UnitProfile/UnitProfile";
import UsageTransactionProfile from "../pages/UsageTransactions/UsageTransactionProfile/UsageTransactionProfile";
import UsageTransactions from "../pages/UsageTransactions/UsageTransactions";
import UserGuide from "../pages/UserGuide/UserGuide";
import UserManagement from "../pages/UserManagement";
import AddUser from "../pages/UserManagements/AddUsers/AddUser";
import UserProfile from "../pages/UserManagements/Userprofile/UserProfile";
import AddVendor from "../pages/VendorMaster/AddVendor/AddVendor";
import VendorListing from "../pages/VendorMaster/VendorListing/VendorListing";
import VendorProfile from "../pages/VendorMaster/VendorProfile/VendorProfile";
import {
  PermissionIdentifier,
  PermissionModule,
} from "../utils/permissionUtils";
import EcwOrderAdministration from "../pages/EcwOrderAdministration/EcwOrderAdministration";
import TemperatureSensor from "../pages/TemperatureSensor/TemperatureSensor";
import TemperatureSensorDetails from "../pages/TemperatureSensor/TemperatureSensorDetails";
import EcwOrderLogs from "../pages/EceOrderLogs/EcwOrderLogs";
import InventoryTransactionReport from "../pages/InventoryManagements/InventoryTransactionReport/InventoryTransactionReport";
import AdhocQuery from "../pages/AdhocQuery/AdhocQuery";
import McOrderProcessor from "../pages/Mckesson/McOrderProcessor/McOrderProcessor";
import McItemsMaster from "../pages/Mckesson/McItemsMaster/McItemsMaster";
import EcwOrderAdministrationTest from "../pages/EcwOrderAdministrationTest/EcwOrderAdministrationTest";
import NdcWhiteListSetup from "../pages/NdcWhiteListSetup/NdcWhiteListSetup";

interface IRoutes {
  path: string;
  element: any;
  permissionConfig?: {
    module: PermissionModule;
    identifier: PermissionIdentifier;
  };
  isCheckRoutePermission?: boolean;
}

/**
 * Application Routes Configuration
 * -------------------
 * - If `isCheckRoutePermission` is true, permission is checked using menuItems (from DB).
 * - If `permissionConfig` is provided, permission is checked via module + identifier.
 * - If neither is provided, the route is allowed for all authenticated users.
 */

export const appRoutes: IRoutes[] = [
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/users",
    element: <UserManagement />,
    isCheckRoutePermission: true,
  },
  {
    path: "/create-user",
    element: <AddUser />,
    permissionConfig: {
      module: PermissionModule.USER_MANAGEMENT,
      identifier: PermissionIdentifier.CREATE_USER,
    },
  },
  {
    path: "/view-user",
    element: <UserProfile />,
  },
  {
    path: "/edit-user",
    element: <AddUser />,
    permissionConfig: {
      module: PermissionModule.USER_MANAGEMENT,
      identifier: PermissionIdentifier.EDIT_USER,
    },
  },
  {
    path: "/user-profile",
    element: <LoginUserProfile />,
  },
  {
    path: "/edit-profile-user",
    element: <AddUserProfile />,
  },
  {
    path: "/records",
    element: <Records />,
    isCheckRoutePermission: true,
  },
  {
    path: "/inventory-status-report",
    element: <InventoryStatusReport />,
    isCheckRoutePermission: true,
  },
  {
    path: "/inventory-expire-report",
    element: <InventoryExpireReport />,
    isCheckRoutePermission: true,
  },
  {
    path: "/inventory-receiving-report",
    element: <InventoryReceivingReport />,
    isCheckRoutePermission: true,
  },
  {
    path: "/usage-detail-report",
    element: <UsageDetailsReport />,
    isCheckRoutePermission: true,
  },
  {
    path: "/transfer-detail-report",
    element: <TransferDetailsReport />,
    isCheckRoutePermission: true,
  },
  {
    path: "/adjustment-detail-report",
    element: <AdjusmentDetailsReport />,
    isCheckRoutePermission: true,
  },
  {
    path: "/reconciliation-report",
    element: <ReconReport />,
    isCheckRoutePermission: true,
  },
  {
    path: "/recalled-inventory-report",
    element: <RecalledInventoryReport />,
    isCheckRoutePermission: true,
  },
  {
    path: "/expiring-inventory-report",
    element: <ExpiringInventoryReport />,
  },
  {
    path: "/email-expired-inventory-report",
    element: <EmailExpiredInventoryReport />,
    isCheckRoutePermission: true,
  },
  {
    path: "/rx-history",
    element: <RxHistoryReport />,
  },
  {
    path: "/cost-history",
    element: <CostHistoryReport />,
  },
  {
    path: "/usage-transactions",
    element: <UsageTransactions />,
    isCheckRoutePermission: true,
  },
  {
    path: "/usage-transactions-profile/:id",
    element: <UsageTransactionProfile />,
  },
  {
    path: "/tr-report",
    element: <TRReport />,
    isCheckRoutePermission: true,
  },
  {
    path: "/inventory",
    element: <Itemlisting />,
    isCheckRoutePermission: true,
  },
  {
    path: "/create-inventory",
    element: <AddItem />,
    permissionConfig: {
      module: PermissionModule.RX,
      identifier: PermissionIdentifier.ADD_INVENTORY_ITEM
    }
  },
  {
    path: "/view-inventory",
    element: <InventoryProfile />,
  },
  {
    path: "/edit-inventory",
    element: <InventoryProfile />,
    permissionConfig: {
      module: PermissionModule.RX,
      identifier: PermissionIdentifier.EDIT_INVENTORY_ITEM
    }
  },
  {
    path: "/inventory-transaction-report",
    element: <InventoryTransactionReport />,
  },
  {
    path: "/inventory-order",
    element: <InventoryOrderList />,
    isCheckRoutePermission: true,
  },
  {
    path: "/inventory-order-detail/:id",
    element: <OrderDetail />,
    permissionConfig: {
      module: PermissionModule.INVENTORY_ORDER,
      identifier: PermissionIdentifier.VIEW_INVENTORY_ORDER
    }
  },
  {
    path: "/providers-list",
    element: <ProvidersList />,
    isCheckRoutePermission: true,
  },
  {
    path: "/locations-list",
    element: <LocationsList />,
    isCheckRoutePermission: true,
  },
  {
    path: "/users-list",
    element: <UsersList />,
    isCheckRoutePermission: true,
  },
  {
    path: "/medications-list",
    element: <MedicationsList />,
    isCheckRoutePermission: true,
  },
  {
    path: "/location-master",
    element: <LocationListing />,
    isCheckRoutePermission: true,
  },
  {
    path: "/view-location",
    element: <LocationProfile />,
    permissionConfig: {
      module: PermissionModule.LOCATION_MASTER,
      identifier: PermissionIdentifier.VIEW_LOCATION_MASTER
    }
  },
  {
    path: "/add-location",
    element: <AddLocation />,
    permissionConfig: {
      module: PermissionModule.LOCATION_MASTER,
      identifier: PermissionIdentifier.CREATE_LOCATION_MASTER
    }
  },
  {
    path: "/edit-location",
    element: <AddLocation />,
    permissionConfig: {
      module: PermissionModule.LOCATION_MASTER,
      identifier: PermissionIdentifier.EDIT_LOCATION_MASTER
    }
  },
  {
    path: "/item-type-master",
    element: <ItemTypeListing />,
    isCheckRoutePermission: true,
  },
  {
    path: "/view-item-master",
    element: <ItemTypeProfile />,
    permissionConfig: {
      module: PermissionModule.ITEM_TYPE_MASTER,
      identifier: PermissionIdentifier.VIEW_ITEM_TYPE,
    }
  },
  {
    path: "/add-item-master",
    element: <AddItemType />,
    permissionConfig: {
      module: PermissionModule.ITEM_TYPE_MASTER,
      identifier: PermissionIdentifier.CREATE_ITEM_TYPE,
    }
  },
  {
    path: "/edit-item-master",
    element: <AddItemType />,
    permissionConfig: {
      module: PermissionModule.ITEM_TYPE_MASTER,
      identifier: PermissionIdentifier.EDIT_ITEM_TYPE,
    }
  },
  {
    path: "/unit-master",
    element: <UnitListing />,
    isCheckRoutePermission: true,
  },
  {
    path: "/view-unit",
    element: <UnitProfile />,
    permissionConfig: {
      module: PermissionModule.UNIT_MASTER,
      identifier: PermissionIdentifier.VIEW_UNIT_MASTER
    }
  },
  {
    path: "/add-unit",
    element: <AddUnit />,
    permissionConfig: {
      module: PermissionModule.UNIT_MASTER,
      identifier: PermissionIdentifier.CREATE_UNIT_MASTER
    }
  },
  {
    path: "/edit-unit",
    element: <AddUnit />,
    permissionConfig: {
      module: PermissionModule.UNIT_MASTER,
      identifier: PermissionIdentifier.EDIT_UNIT_MASTER
    }
  },
  {
    path: "/stock-master",
    element: <StockListing />,
    isCheckRoutePermission: true,
  },
  {
    path: "/view-stock",
    element: <StockProfile />,
  },
  {
    path: "/add-stock",
    element: <AddStock />,
  },
  {
    path: "/edit-stock",
    element: <AddStock />,
  },
  {
    path: "/product-master",
    element: <ProductMasterListing />,
    isCheckRoutePermission: true,
  },
  {
    path: "/view-product-master",
    element: <ProductMasterProfile />,
    permissionConfig: {
      identifier: PermissionIdentifier.VIEW_PRODUCT_MASTER,
      module: PermissionModule.PRODUCT_MASTER
    }
  },
  {
    path: "/add-product-master",
    element: <AddProductMaster />,
    permissionConfig: {
      identifier: PermissionIdentifier.CREATE_PRODUCT_MASTER,
      module: PermissionModule.PRODUCT_MASTER
    }
  },
  {
    path: "/edit-product-master",
    element: <AddProductMaster />,
    permissionConfig: {
      identifier: PermissionIdentifier.EDIT_PRODUCT_MASTER,
      module: PermissionModule.PRODUCT_MASTER
    }
  },
  {
    path: "/vendor-master",
    element: <VendorListing />,
    isCheckRoutePermission: true,
  },
  {
    path: "/view-vendor",
    element: <VendorProfile />,
    permissionConfig: {
      identifier: PermissionIdentifier.VIEW_VENDOR_MASTER,
      module: PermissionModule.VENDER_MASTER
    }
  },
  {
    path: "/add-vendor",
    element: <AddVendor />,
    permissionConfig: {
      identifier: PermissionIdentifier.CREATE_VENDOR_MASTER,
      module: PermissionModule.VENDER_MASTER
    }
  },
  {
    path: "/edit-vendor",
    element: <AddVendor />,
    permissionConfig: {
      identifier: PermissionIdentifier.EDIT_VENDOR_MASTER,
      module: PermissionModule.VENDER_MASTER
    }
  },
  {
    path: "/patient-master",
    element: <PatientsListing />,
    isCheckRoutePermission: true,
  },
  {
    path: "/view-patient/:id",
    element: <PatientProfile />,
    permissionConfig: {
      module: PermissionModule.PATIENT_MASTER,
      identifier: PermissionIdentifier.VIEW_PATIENT_MASTER
    }
  },
  {
    path: "/add-patient",
    element: <AddPatients />,
    permissionConfig: {
      module: PermissionModule.PATIENT_MASTER,
      identifier: PermissionIdentifier.CREATE_PATIENT_MASTER
    }
  },
  {
    path: "/edit-patient/:id",
    element: <AddPatients />,
    permissionConfig: {
      module: PermissionModule.PATIENT_MASTER,
      identifier: PermissionIdentifier.EDIT_PATIENT_MASTER
    }
  },
  {
    path: "/ordering-product-master",
    element: <OrderingProductListing />,
    isCheckRoutePermission: true,
  },
  {
    path: "/view-ordering-product",
    element: <OrderingProductProfile />,
    permissionConfig: {
      identifier: PermissionIdentifier.VIEW_ORDERING_PRODUCT_MASTER,
      module: PermissionModule.ORDERING_PRODUCT_MASTER
    }
  },
  {
    path: "/add-ordering-product",
    element: <AddOrderingProduct />,
    permissionConfig: {
      identifier: PermissionIdentifier.CREATE_ORDERING_PRODUCT_MASTER,
      module: PermissionModule.ORDERING_PRODUCT_MASTER
    }
  },
  {
    path: "/edit-ordering-product",
    element: <AddOrderingProduct />,
    permissionConfig: {
      identifier: PermissionIdentifier.EDIT_ORDERING_PRODUCT_MASTER,
      module: PermissionModule.ORDERING_PRODUCT_MASTER
    }
  },
  {
    path: "/ordering-product-report",
    element: <OrderingProductReport />,
  },
  {
    path: "/ordering-product-inventory-report",
    element: <OrderingProductInventoryReport />,
  },
  {
    path: "/roles-permissions",
    element: <RoleListing />,
    isCheckRoutePermission: true,
  },
  {
    path: "/add-role",
    element: <AddRole />,
    permissionConfig: {
      module: PermissionModule.ROLES_AND_PERMISSION,
      identifier: PermissionIdentifier.CREATE_ROLES_AND_PERMISSION
    }
  },
  {
    path: "/edit-role/:id",
    element: <AddRole />,
    permissionConfig: {
      module: PermissionModule.ROLES_AND_PERMISSION,
      identifier: PermissionIdentifier.EDIT_ROLES_AND_PERMISSION
    }
  },
  {
    path: "/settings",
    element: <Settings />,
    isCheckRoutePermission: true,
  },
  {
    path: "/add-setting",
    element: <AddSetting />,
    permissionConfig: {
      identifier: PermissionIdentifier.CREATE_SETTINGS,
      module: PermissionModule.SETTINGS
    }
  },
  {
    path: "/edit-setting/:id",
    element: <AddSetting />,
    permissionConfig: {
      identifier: PermissionIdentifier.EDIT_SETTINGS,
      module: PermissionModule.SETTINGS
    }
  },
  {
    path: "/view-setting/:id",
    element: <SettingProfile />,
    permissionConfig: {
      identifier: PermissionIdentifier.VIEW_SETTINGS,
      module: PermissionModule.SETTINGS
    }
  },
  {
    path: "/athena-settings",
    element: <AthenaSettings />,
    isCheckRoutePermission: true,
  },
  {
    path: "/athena-transaction",
    element: <AthenaTransactions />,
    isCheckRoutePermission: true,
  },
  {
    path: "/view-transaction/:id",
    element: <AthenaTransactionProfile />,
  },
  {
    path: "/edit-transaction/:id",
    element: <AthenaTransactionAdd />,
  },
  {
    path: "/item-warning-master",
    element: <WarningItemListing />,
    isCheckRoutePermission: true,
  },
  {
    path: "/item-warning-profile/:id",
    element: <WarningItemProfile />,
  },
  {
    path: "/add-item-warning",
    element: <AddWarningItem />,
  },
  {
    path: "/edit-item-warning/:id",
    element: <AddWarningItem />,
  },
  {
    path: "/label-setup",
    element: <LabelListing />,
    isCheckRoutePermission: true,
  },
  {
    path: "/label-details/:id",
    element: <LabelDetails />,
    permissionConfig: {
      module: PermissionModule.LABEL_SETUP,
      identifier: PermissionIdentifier.VIEW_LABEL_SETUP
    }
  },
  {
    path: "/add-label",
    element: <AddLabel />,
    permissionConfig: {
      module: PermissionModule.LABEL_SETUP,
      identifier: PermissionIdentifier.CREATE_LABEL_SETUP
    }
  },
  {
    path: "/edit-label/:id",
    element: <AddLabel />,
    permissionConfig: {
      module: PermissionModule.LABEL_SETUP,
      identifier: PermissionIdentifier.EDIT_LABEL_SETUP
    }
  },
  {
    path: "/lot-search-item",
    element: <LotSearchItem />,
    isCheckRoutePermission: true,
  },
  {
    path: "/lot-search-patients",
    element: <LotSearchPatients />,
    isCheckRoutePermission: true,
  },
  {
    path: "/api-message-log",
    element: <ApiMsgLog />,
    isCheckRoutePermission: true,
  },
  {
    path: "/user-guide",
    element: <UserGuide />,
    isCheckRoutePermission: true,
  },
  {
    path: "/contact-us",
    element: <ContactUs />,
    isCheckRoutePermission: true,
  },
  {
    path: "/tickets",
    element: <Tickets />,
    isCheckRoutePermission: true,
  },
  {
    path: "/about-us",
    element: <AboutUs />,
    isCheckRoutePermission: true,
  },
  {
    path: "/faqs",
    element: <Faq />,
    isCheckRoutePermission: true,
  },
  {
    path: "/predictions",
    element: <Predictions />,
    isCheckRoutePermission: true,
  },
  {
    path: "/refrigerators",
    element: <RefrigeratorList />,
  },
  {
    path: "/add-refrigerator",
    element: <AddRefrigerator />,
  },
  {
    path: "/edit-refrigerator",
    element: <AddRefrigerator />,
  },
  {
    path: "/custom-fields-master",
    element: <CustomFieldsManagement />,
    isCheckRoutePermission: true,
  },
  {
    path: "/create-custom-fields",
    element: <CreateCustomFields />,
    permissionConfig: {
      module: PermissionModule.CUSTOM_FIELD_MASTER,
      identifier: PermissionIdentifier.CREATE_CUSTOM_FIELD_MASTER
    }
  },
  {
    path: "/edit-custom-fields/:id",
    element: <EditCustomFields />,
    permissionConfig: {
      module: PermissionModule.CUSTOM_FIELD_MASTER,
      identifier: PermissionIdentifier.EDIT_CUSTOM_FIELD_MASTER
    }
  },
  {
    path: "/view-custom-fields/:id",
    element: <EditCustomFields />,
    permissionConfig: {
      module: PermissionModule.CUSTOM_FIELD_MASTER,
      identifier: PermissionIdentifier.VIEW_CUSTOM_FIELD_MASTER
    }
  },
  {
    path: "/ecw-order-administration",
    element: <EcwOrderAdministration />,
    isCheckRoutePermission: true,
  },
  {
    path: "/ecw-order-logs",
    element: <EcwOrderLogs />,
  },
  {
    path: "/temperature-sensor",
    element: <TemperatureSensor />,
    isCheckRoutePermission: true,
  },
  {
    path: "/manage-sensor",
    element: <TemperatureSensorDetails />,
  },
  {
    path: "/adhoc-query",
    element: <AdhocQuery />,
    isCheckRoutePermission: true,
  },
  {
    path: "/mckesson-order-processor",
    element: <McOrderProcessor />,
    isCheckRoutePermission: true,
  },
  {
    path: "/mckesson-items-master",
    element: <McItemsMaster />,
    isCheckRoutePermission: true,
  },
  {
    path: "/ecw-order-administration-test",
    element: <EcwOrderAdministrationTest />,
    isCheckRoutePermission: true,
  },
  {
    path: "/ndc-whitelist-setup",
    element: <NdcWhiteListSetup />,
    isCheckRoutePermission: true,
  },
];
